import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { antArr } from "./lib/AntDesignVue";
import { vantArr } from "./lib/Vant";
import * as Icons from "@ant-design/icons-vue"; //图标使用
import Axios from "./request/https";
import lazyload from "./directives/lazyload";
import pinia from "./store";
import "vant/lib/index.css";
// import "@/assets/fontFamily/font.css";
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";

import i18n from "@/i18n/langs/i18n";

import VueCookies from "vue-cookies";
import VueMeta from 'vue-meta';

const app = createApp(App);

app.directive("lazyload", lazyload);

for (let item of antArr) {
  app.use(item);
}
for (let item of vantArr) {
  app.use(item);
}

for (const i in Icons) {
  //图标使用
  app.component(i, Icons[i]);
}

// app.use(VueMeta, {
//   // 配置项
//   keyName: 'metaInfo', // 组件中用来定义元信息的属性名
// });

app
  .use(VueCookies)
  .use(i18n)
  .use(router)
  .use(Axios)
  .use(pinia)
  .use(VideoPlayer)
  .mount("#app");
